<template>
  <div class="modal-card m-0" style="width: auto">
    <header class="modal-card-head" v-show="!showReset">
      <p class="modal-card-title has-text-centered">{{ $t('general.login') }}</p>
    </header>
    <section class="modal-card-body" v-if="!forgotten">
      <ValidationObserver v-slot="{invalid}">
        <form>
          <b-notification type="is-danger" has-icon v-if="error" :closable="false">
            <strong>{{ $t('errors.invalid-user-data') }}</strong>
            <p class="is-size-7">{{ $t('errors.check-input') }}</p> </b-notification
          ><ValidationProvider name="E-Mail" :rules="{required: true}" v-slot="{errors}">
            <b-field :label="$t('general.email')">
              <b-input v-model="userName"></b-input>
              <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <ValidationProvider name="Passwort" :rules="{required: true}" v-slot="{errors}">
            <b-field :label="$t('general.password')">
              <b-input type="password" v-model="password" password-reveal @keyup.enter.native="login"></b-input>
              <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <b-button type="is-primary" size="is-medium" :disabled="invalid" class="is-fullwidth mt-4" @click="login">{{ $t('general.login') }}</b-button>
        </form>
      </ValidationObserver>
    </section>
    <section class="modal-card-body" v-if="forgotten">
      <b-notification type="is-success" has-icon v-if="resetSuccess" :closable="false">
        {{ $t('account.recovery-mail-has-been-sent') }}
      </b-notification>
      <b-notification type="is-danger" has-icon v-if="errorreset" :closable="false">
        <strong>{{ $t('errors.invalid-email-address') }}</strong>
        <p class="is-size-7">{{ $t('errors.unknown-email') }}</p>
      </b-notification>
      <ValidationObserver v-slot="{invalid}">
        <ValidationProvider name="E-Mail" :rules="{required: true, email: true}" v-slot="{errors}">
          <b-field :label="$t('general.email')">
            <b-input type="text" v-model="email"></b-input>
            <p class="help is-danger" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
        <b-button type="is-primary" size="is-medium" :disabled="invalid" @click="reset" class="is-fullwidth mt-4">{{ $t('account.password-reset') }}</b-button>
      </ValidationObserver>
    </section>
    <footer class="modal-card-foot" v-show="!showReset">
      <small v-if="!forgotten"
        ><a v-on:click="forgotten = true">{{ $t('account.password-forgotten') }}</a></small
      >
      <small v-if="forgotten"
        ><a v-on:click="forgotten = false">{{ $t('account.back-to-login') }}</a></small
      >
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LoginWindow',
  props: {
    showReset: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userName: '',
      password: '',
      error: false,
      forgotten: false,
      errorreset: false,
      resetSuccess: false,
      email: '',
    }
  },
  mounted() {
    if (this.showReset) {
      this.forgotten = true
    }
  },
  methods: {
    async login() {
      let res = await this.$store.dispatch('login', {usr: this.userName, pwd: this.password})
      this.error = !res.success
    },
    async reset() {
      let res = await this.$store.dispatch('passwordForgotten', {email: this.email})
      this.errorreset = !res.success
      this.resetSuccess = res.success
    },
  },
}
</script>

<style lang="scss" scoped>
// .login {
//   height: 100vh;
//   margin-top: -5rem;
// }

.modal-card-foot {
  justify-content: center;
}
</style>
